export default {
  paused: 'Verkkomaksut on keskeytetty KYC-vahvistusongelmien vuoksi.',
  deadline_warning: 'KYC-vahvistus vaaditaan, muuten verkkomaksut keskeytetään {{date}}.',
  complete_verification: 'Viimeistele vahvistus',
  partner: {
    action_needed:
      'Maksupalveluntarjoajasi tarvitsee vielä yhden asian, ennen kuin tämä ravintola voi ottaa vastaan verkkomaksuja.',
    hosted_incomplete: 'Et ole vielä viimeistellyt verkkomaksujen käyttöönottoa maksupalveluntarjoajasi kanssa.',
    link_expired: 'Linkkisi verkkomaksujen käyttöönoton viimeistelyyn on vanhentunut. Hanki uusi ja jatka.',
    open_error: 'Maksupalveluntarjoajaan ei saatu yhteyttä. Yritä uudelleen muutaman minuutin kuluttua.',
    hosted_not_started: 'Verkkomaksuja ei ole vielä otettu käyttöön maksupalveluntarjoajallasi.',
    business_details_missing: 'Lisää yrityksesi tiedot aloittaaksesi verkkomaksujen vastaanottamisen.',
    continue: 'Jatka',
  },
};
